import React from 'react';
import { Container, Col, Row, Button } from 'react-bootstrap';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router-dom';

const Error = () => {
  const history = useHistory();

  return (
    <Container fluid="md">
      <Helmet>
        <title>Error{process.env.REACT_APP_PAGETITLE_TEXT}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <Row>
        <Col></Col>
        <Col xs={8}>
          <br />
          <h2>Error</h2>
          <p className="textup">
            We encountered an error - return to previous page below.
          </p>
          <Button
            variant="outline-dark"
            className="m-1"
            size="md"
            onClick={() => history.goBack()}
          >
            Return
          </Button>
        </Col>
        <Col></Col>
      </Row>
    </Container>
  );
};

export default Error;
